import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { formatPrice, ZemplinLoaderWrapper } from '../../..';
import { TableWrapper } from '../General/TableWrapper';
import { TableRow, SecondTableTh } from '../General/Table';
import { DsiPayableRow as PayableRow } from './PayableRow';
import { Filters } from './Invoices';
import { Select } from '../../Zemplin/General/Select';

interface Props {
  orders: any;
  isFetching: boolean;
  currency: string;
  refetchData?: any;
  downloadFile: any;
}

function Payables({
  orders,
  isFetching,
  currency,
  refetchData,
  downloadFile,
}: Props) {
  const [selectState, setSelectState] = React.useState('all');

  const columns = [
    { name: __('Č. dokladu') },
    { name: __('Dátum') },
    { name: __('Dátum splatnosti') },
    { name: __('Celková suma'), align: 'right' },
    { name: __('Uhradená suma'), align: 'right' },
    { name: __('K úhrade'), align: 'right' },
    { name: __('Dni po splatnosti'), align: 'right' },
  ];
  const footerColumns = [
    { name: '' },
    { name: '' },
    { name: '' },
    { name: '' },
    { name: '' },
    { name: '' },
    { name: '' },
  ];
  const headers =
    columns &&
    columns.map((item: any) => (
      <SecondTableTh
        width={item.width}
        minWidth={item.minWidth}
        align={item.align || 'left'}
        key={item.name}
      >
        {item.name}
      </SecondTableTh>
    ));

  const footers =
    footerColumns &&
    footerColumns.map((item: any) => (
      <SecondTableTh
        width={item.width}
        minWidth={item.minWidth}
        align={item.align || 'left'}
        key={item.name}
      >
        {item.name}
      </SecondTableTh>
    ));

  const orderRows =
    orders &&
    orders.map(o => {
      return (
        <PayableRow
          downloadFile={downloadFile}
          order={o}
          key={o['@_InvCus_OrdId']}
          currency={currency}
        />
      );
    });
  // const orderRows =
  //   selectState === 'all'
  //     ? orders.map(o => {
  //         return (
  //           <PayableRow
  //             order={o}
  //             key={o['@_InvCus_OrdId']}
  //             currency={currency}
  //           />
  //         );
  //       })
  //     : selectState === 'invoices'
  //     ? orders
  //         .filter(o => o['@_InvCus_Type'] === 73)
  //         .map(o => {
  //           return (
  //             <PayableRow
  //               order={o}
  //               key={o['@_InvCus_OrdId']}
  //               currency={currency}
  //             />
  //           );
  //         })
  //     : orders
  //         .filter(o => o['@_InvCus_Type'] === 67)
  //         .map(o => {
  //           return (
  //             <PayableRow
  //               order={o}
  //               key={o['@_InvCus_OrdId']}
  //               currency={currency}
  //             />
  //           );
  //         });

  const onChangeSelect = e => {
    const {
      target: { value },
    } = e;
    setSelectState(value);
    refetchData({ type: value });
  };

  return (
    <Wrapper>
      <Filters>
        <Select
          value={selectState}
          options={[
            { name: __('Všetky'), value: '' },
            { name: __('Faktúry'), value: 'INVOICE' },
            { name: __('Dobropisy'), value: 'CREDIT' },
          ]}
          onChange={onChangeSelect}
          maxWidth={240}
          backgroundColor={'#FFFFFF'}
          marginRight={14}
        />
      </Filters>
      {isFetching ? (
        <ZemplinLoaderWrapper height={500} />
      ) : (
        <TableWrapper
          tableHasBorder={true}
          tableHasBoxShadow={true}
          noItemsText={__('Nenašli sa žiadne záväzky')}
          headers={headers}
          footers={footers}
          rows={orderRows}
          overflowX={true}
        />
      )}
    </Wrapper>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;
  margin-bottom: ${rem(24)};
  animation: ${animateIn} 0.2s ease;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
      margin: 0;
      margin-bottom: ${({ visible }) => (visible ? rem(32) : 0)};
      margin-right: -${rem(16)};
  `};
`;

export { Payables as DsiPayables };
